/* istanbul ignore file */
import { HTMLAttributes } from 'react';
import { DataAnalyticsLocations } from '../../basic/analytics';

export interface IActionList {
  title: string;
  url: string;
  isExternal: boolean;
}

export interface ICard {
  theme: string;
  header: string;
  description: string;
  tileFontColor: string;
  tileLayout: 'left-facing' | 'center-facing' | 'right-facing';
  navigation: Array<IActionList>;
  icon: string;
  event?: string;
  banner_style?: any;
  navigationPanel?: any;
  phone?: string;
}

export interface IContent {
  alt: string;
  card: ICard | undefined;
  layout: 'left-facing' | 'center-facing' | 'right-facing';
  src: string;
  position?: number; // To determine the postion of tiles or content or any other item added with the same type on UI
  banner_style?: any;
}

export type ITiles = IContent;

export type IBanner = IContent;

export enum MARKETINGCONTENTTYPE {
  TILES = 'stack_tiles_horizontal_',
  BANNERS = 'content_row',
  CAROUSEL = 'product_carousel',
}

export interface IMarketingGrid {
  content: Array<IContent>;
  tiles: Array<ITiles>;
}

export interface IMarketingGridItem {
  position: number;
  type: MARKETINGCONTENTTYPE;
  value: Array<IContent | ITiles>;
}

export interface MarketingContentProps extends HTMLAttributes<HTMLDivElement> {
  banner: IContent;
  parentAnalyticsLocation: DataAnalyticsLocations;
}

export interface MarketingTileProps extends HTMLAttributes<HTMLDivElement> {
  banner: ITiles;
  tileIndex: number;
  parentAnalyticsLocation: DataAnalyticsLocations;
}

export interface IMarketingGridProps extends HTMLAttributes<HTMLDivElement> {
  marketingProps: IMarketingGridItem[];
}

export interface IMarketingTiles {
  tiles: IContent[];
  className: string;
  parentAnalyticsLocation: DataAnalyticsLocations;
}
export interface IMarketingBanners {
  banners: IContent[];
  parentAnalyticsLocation: DataAnalyticsLocations;
}
